import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import useCloudFunction from '../clouds/useCloudFunction';

const useGetCorporations = params => {
  const { corporationId = null, runFirstTime = false, isActive = true } = params || {};
  const {
    data: corporations,
    loading,
    error,
  } = useCloudFunction({
    params: { corporationId, isActive },
    op: API_OPERATIONS.CORPORATION_LIST_DT,
    runFirstTime,
    dependencies: [isActive],
  });

  const getCorporationById = async id => {
    const httpRef = apiCallable(API_OPERATIONS.CORPORATION_LIST_DT);
    return httpRef({ corporationId: id });
  };

  const getOrgByCorporation = async id => {
    const httpRef = apiCallable(API_OPERATIONS.ORG_BY_CORPORATION_DT);
    return httpRef({ corporationId: id });
  };

  return { data: corporations, loading, error, getCorporationById, getOrgByCorporation };
};

export default useGetCorporations;
